import { OrderExpiredReportActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { GetProviderReportsAction } from './providerReport-actions';
export interface GetOrderExpiredReportsAction {
    type: typeof OrderExpiredReportActions.FETCH_ORDER_EXPIRED_REPORTS;
    payload: QueryParams;
    all?: any;
}

export function getOrderExpiredReports(params: QueryParams): GetOrderExpiredReportsAction {
    return {
        type: OrderExpiredReportActions.FETCH_ORDER_EXPIRED_REPORTS,
        payload: params,
    };
}

interface QueryParamsAll extends QueryParams {
    all?: any;
}
export function getOrderExpiredReportsCsv(params: QueryParamsAll): GetProviderReportsAction {
    return {
        type: OrderExpiredReportActions.FETCH_ORDER_EXPIRED_REPORTS_CSV,
        payload: params,
    };
}

export interface GetOrderExpiredReportAction {
    type: typeof OrderExpiredReportActions.FETCH_ORDER_EXPIRED_REPORT;
    payload: {
        id: string | number;
    };
}

export function getOrderExpiredReport(id: string | number): GetOrderExpiredReportAction {
    return {
        type: OrderExpiredReportActions.FETCH_ORDER_EXPIRED_REPORT,
        payload: { id },
    };
}

export interface DeleteOrderExpiredReportAction {
    type: typeof OrderExpiredReportActions.DELETE_ORDER_EXPIRED_REPORT;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteOrderExpiredReport(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteOrderExpiredReportAction {
    return {
        type: OrderExpiredReportActions.DELETE_ORDER_EXPIRED_REPORT,
        payload: { id, onSuccess, onError },
    };
}

export type Actions = GetOrderExpiredReportsAction | GetOrderExpiredReportAction | DeleteOrderExpiredReportAction;
